import React from 'react';
import PropTypes from 'prop-types';
import {Field} from 'redux-form';

import Form from '@appComponents/ReduxFormControls';

export const ContentCategoriesFilter = ({
    contentCategories = [],
    loading,
    filters,
    restoreFilterValues,
    filterName,
}) => (
    <Field
        component={Form.ReduxSelect}
        name='contentCategories'
        options={contentCategories}
        disabled={loading}
        placeholder='Content category'
        loading={loading}
        className='long'
        setValue={restoreFilterValues(filters[filterName], 'contentCategories') ?? ''}
        search
        multiple
        selection
    />
);

ContentCategoriesFilter.propTypes = {
    contentCategories: PropTypes.array,
    loading: PropTypes.bool,
    filters: PropTypes.object.isRequired,
    restoreFilterValues: PropTypes.func.isRequired,
    filterName: PropTypes.string.isRequired,
};
